export class MDExServicemanBodyModel {
    constructor(
        public nameAsOnCertificate: string,
        public serviceName: string,
        public applicantType: string,
        public relationshipWithEX: string,
        public isStampReadable: string,
        public isStampFromZSWB: string,
        public isSignaturePresent: string,
        public isDateOfIssuePresent: string,
        // public isQRCodePresent: string,
    ) { }
}